import React from 'react';
import { getComponentClasses } from '../../utils/app';

export interface Props {
    title?: string;
    variations?: string[];
    children: React.ReactNode;
    onDelete?: () => void;
    deleteButtonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

const Pill = ({ title, variations = ['tag'], children, onDelete, deleteButtonProps }: Props) => (
    <span
        className={getComponentClasses('pill', variations.concat(onDelete ? ['deletable'] : []))}
        title={title}
    >
        {children}
        {onDelete && (
            <button
                {...deleteButtonProps}
                type="button"
                className="pill__delete"
                onClick={onDelete}
            />
        )}
    </span>
);

export default Pill;
